import { render, staticRenderFns } from "./UmsPasswordChangeActivator.vue?vue&type=template&id=de915eea&"
import script from "./UmsPasswordChangeActivator.vue?vue&type=script&lang=js&"
export * from "./UmsPasswordChangeActivator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports